import React from 'react';
// Data
import { mainRatesArray } from '../../utils/data/PriceData';
// Components
import GeneralPriceTable from '../general/GeneralPriceTable';
import SmallGalleryComponent from '../gallery/SmallGalleryComponent';
import HomeServicesSection from './HomeServicesSection';
import ImageBannerCta from '../cta/ImageBannerCta';

function HomePageMainContainer() {
  return (
    <main role='main' className='grid gap-24 pt-24 w-full h-full'>
      <HomeServicesSection />

      {/* Gallery */}
      <SmallGalleryComponent />
      
      {/* Prices */}
      <GeneralPriceTable
        title="Session Rates"
        rates={mainRatesArray}
        depositMessage="A £60 deposit (non-negotiable & non-refundable) is required to secure a booking."
        extraMessage="Extras apply for sessions involving mess, topless, or nudity."
      />

      {/* Cta */}
      <ImageBannerCta />
    </main>
  );
}

export default HomePageMainContainer;
